<script setup lang="ts">
import type { ContactInformation } from '~~/types/app'

defineProps<{
  contactInfo?: ContactInformation
}>()
</script>

<template>
  <div class="side-promo-block prose">
    <div
      v-if="contactInfo?.customerServiceTitle"
      class="h6 bold mb-2"
    >
      {{ contactInfo.customerServiceTitle }}
    </div>
    <div
      v-if="contactInfo?.customerServiceBody"
      class="side-promo-block__body prose"
      v-html="contactInfo.customerServiceBody"
    />
    <div
      v-if="contactInfo?.contactNumbersTitle"
      class="h6 bold mb-2"
    >
      {{ contactInfo.contactNumbersTitle }}
    </div>
    <div
      v-if="contactInfo?.contactNumbers?.length"
      class="side-promo-block__contacts prose info"
    >
      <p
        v-for="contact in contactInfo.contactNumbers"
        :key="contact.label"
      >
        <span class="font-medium">
          {{ contact.label }}:
        </span>
        {{ contact.text }}
      </p>
    </div>
    <div
      v-if="contactInfo?.addressTitle"
      class="h6 bold mb-2"
    >
      {{ contactInfo.addressTitle }}
    </div>
    <div
      v-if="contactInfo?.addressBody"
      class="side-promo-block__body prose"
      v-html="contactInfo.addressBody"
    />
    <div
      v-if="contactInfo?.locationTitle"
      class="h6 bold mb-2"
    >
      {{ contactInfo.locationTitle }}
    </div>
    <div
      v-if="contactInfo?.locationBody"
      class="side-promo-block__body prose"
      v-html="contactInfo.locationBody"
    />
    <div
      v-if="contactInfo?.locationsLink?.url && contactInfo?.locationsLink?.text"
    >
      <ULink
        class="text-primary"
        :to="useCmsUrl(contactInfo.locationsLink.url)"
        :locale="false"
      >
        {{ contactInfo.locationsLink.text }} >>
      </ULink>
    </div>
    <ul
      v-if="contactInfo?.socialLinks?.length"
      class="side-promo-block__social"
    >
      <li
        v-for="link in contactInfo.socialLinks"
        :key="link.url"
      >
        <ULink
          :to="useCmsUrl(link.url)"
          :locale="false"
          class="h-9 w-9"
        >
          <NuxtImg
            provider="fastlyAprimo"
            :src="link.icon?.imageUrl"
            :alt="link.icon?.imageAltText"
            :width="35"
            :height="35"
            loading="lazy"
          />
        </ULink>
      </li>
    </ul>
    <div class="flex justify-center">
      <UButton
        v-if="contactInfo?.jobInquiriesLink?.text && contactInfo?.jobInquiriesLink?.url"
        :to="useCmsUrl(contactInfo.jobInquiriesLink.url)"
        :locale="false"
        variant="solid"
        color="warning"
        :label="contactInfo.jobInquiriesLink.text"
        class="no-underline cursor-pointer"
      />
    </div>
  </div>
</template>

<style lang="scss">
@use '@/assets/css/blocks/side-promo-block.scss';
</style>
